import FaceAndBodyCarouselSkeleton from "./FaceAndBodyCarouselSkeleton";

const ErrorComponent = () => <FaceAndBodyCarouselSkeleton isError={true} />;

export default ErrorComponent;
